export default __webpack_public_path__ + "static/media/4.38f1ae76.png";